import React, { useEffect, useRef, useState } from 'react';
import lottie from 'lottie-web';
import cn from 'classnames';

import { selectConfig } from 'src/store/config/selectors';
import { useAppSelector } from 'src/hooks/store';
import { useSearch } from './Search/Context';

import Search from './Search';
import Background from './Background';

import animationData from 'src/assets/header/header-animation.json';

import css from './FilterSection.module.scss';

export const FilterSection = () => {
  const search = useSearch();
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);
  const t = useAppSelector(selectConfig).texts.website.main.header;
  const totalItems = search.result?.success ? search.result.data.page.total : 0;
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onPageLoad = () => {
      if (document.readyState === 'complete') {
        setIsPageLoaded(true);
      }
    };

    if (document.readyState === 'complete') {
      setIsPageLoaded(true);
    }

    window.addEventListener('load', onPageLoad, false);
    return () => window.removeEventListener('load', onPageLoad);
  }, [isPageLoaded]);

  useEffect(() => {
    const logo = logoRef.current;

    if (logo) {
      lottie.loadAnimation({
        container: logo,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationData,
      });
    }

    return () => lottie.destroy();
  }, []);

  return (
    <section className={css.filterSection}>
      <div className={cn(css.videoWrap, isPageLoaded && css.videoBg)}>
        {isPageLoaded && <Background className={css.background} />}
        <div className={css.backgroundImg} />
        <div className={css.gradient} />
      </div>
      <div className={css.content}>
        <div className={css.logoAnimation} ref={logoRef} />
        <div className={css.title}>
          <div className={css.stripes}>
            <div />
            <div />
          </div>
          <span>{t.title}</span>
        </div>
        <div className={css.subtitle}>
          <span>{t.subTitle}</span>
        </div>
        <Search />
        {!totalItems && <div className={css.noResult} dangerouslySetInnerHTML={{ __html: t.noResult }} />}
      </div>
    </section>
  );
};
